// extracted by mini-css-extract-plugin
export default {"icon":"MessageModalMobile_icon__JV+jY","title":"MessageModalMobile_title__urAKq","header":"MessageModalMobile_header__lbxEc","description":"MessageModalMobile_description__EajF6"};